import Checkbox from '@rio-cloud/rio-uikit/Checkbox';
import classnames from 'classnames';

import type { DiscountCampaign } from './types';

interface Props {
    campaign: DiscountCampaign;
    edit: () => void;
    editEnabled: boolean;
}

export function CampaignRow({ campaign, edit, editEnabled }: Props) {
    return (
        <tr>
            <td>{campaign.name}</td>
            <td>
                <Checkbox checked={Boolean(campaign.costAbsorption)} className={'pointer-events-none'} />
            </td>
            <td>{campaign.startsAt ?? 'not set'}</td>
            <td>{campaign.endsAt ?? 'not set'}</td>
            <td>
                <button
                    type={'button'}
                    className={classnames('btn btn-action btn-icon-only text-size-12', !editEnabled && 'disabled')}
                    onClick={edit}
                    aria-label='edit'
                >
                    <span className='uikit-icon icon-pencil' aria-hidden='true' />
                </button>
            </td>
        </tr>
    );
}
